let enabled = false;
if (import.meta.env.VUE_APP_ENV === 'staging' || import.meta.env.VUE_APP_ENV === 'production') {
  enabled = true;
}

export default {
  accessToken: import.meta.env.VUE_APP_ROLLBAR_API_KEY,
  captureUncaught: enabled,
  captureUnhandledRejections: enabled,
  payload: {
    environment: import.meta.env.VUE_APP_ENV,
  },
};
